export default {"src":"/_next/static/media/swiftIcon.7abf1409.svg","height":32,"width":32};